<template>
  <v-container>
    <v-card v-if="!loaded" flat color="transparent" loading>
      <v-progress-linear indeterminate color="green darken-2" />
    </v-card>
    <v-card v-else-if="!success" flat color="transparent">
      <v-card-title>
        {{ $dictionary.get('order-info-title-404') }}
      </v-card-title>
      <v-card-text>
        {{ $dictionary.get('order-info-text-404') }}
      </v-card-text>
    </v-card>
    <v-card v-else flat color="transparent" :loading="loading">
      <v-card-title>
        {{ title }}
        <v-btn icon :loading="loading" @click="load">
          <v-icon>mdi-autorenew</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        <div>{{ $dictionary.get('order-generated') }}: <b>{{ generated }}</b></div>
        <div>{{ $dictionary.get('order-date') }}: <b>{{ date }}</b></div>
        <div>{{ $dictionary.get('order-sum') }}: <b>{{ sum }}</b></div>
      </v-card-subtitle>
      <v-card-title>Состав заказа</v-card-title>
      <v-card-subtitle>
        <ProductsTable :keys="keys"
                       :items="items"
                       :totals="totals"
                       :delivery="Number(order.price_delivery)"
        />
      </v-card-subtitle>
      <v-card-title v-if="order.paymentURL && order.paymentData">
        <PaymentFormRobokassa :url="order.paymentURL"
                              :params="order.paymentData"
        />
      </v-card-title>
      <v-card-title class="text-center d-flex flex-column">
        <div>Ссылка на эту страницу</div>
        <div class="canvas-holder">
          <canvas ref="canvas" class="mx-auto" />
        </div>
      </v-card-title>
    </v-card>
  </v-container>
</template>

<script>
import ProductsTable from '@/components/ProdcutsTable';
import QRCode from 'qrcode';
import PaymentFormRobokassa from '@/components/PaymentFormRobokassa';

export default {
  name: 'OrderInfo',
  components: { PaymentFormRobokassa, ProductsTable },
  props: {},
  data: () => ({
    success: false,
    loading: false,
    loaded: false,
    order: {}
  }),
  computed: {
    totals() {
      if (!this.order || !this.order.items) return {};
      let quantity = 0;
      this.order.items.forEach((item) => { quantity += Number(item.quantity); });
      return {
        price: this.order.price_full,
        quantity
      };
    },
    keys() {
      return ['name', 'quantity', 'price', 'sum'];
    },
    title() {
      if (this.order.status === 'pending') {
        const part1 = this.$dictionary.get('order-status-pending-text-1');
        const part2 = this.$dictionary.get('order-status-pending-text-2');
        return `${part1} #${this.order.order_number} ${part2}`;
      }
      const part1 = this.$dictionary.get('order-status-other-text');
      const key = `order-status-${this.order.status}`;
      const part2 = this.$dictionary.get(key);
      return `${part1} #${this.order.order_number}: ${part2}`;
    },
    date() {
      return this.$tools.date.format(this.order.when_created);
    },
    generated() {
      return this.$tools.date.format(this.order.when_generated);
    },
    sum() {
      return this.$tools.money(this.order.price_full);
    },
    items() {
      if (!this.order || !this.order.items) return [];
      return this.order.items.map((item) => ({
        ...item,
        sum: Number(item.price) * Number(item.quantity)
      }));
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    showQR() {
      const text = window.location.href;
      QRCode.toCanvas(this.$refs.canvas, text, { width: '400', margin: 1 });
    },
    async load() {
      this.loading = true;
      const { hash } = this.$route.params;
      const data = await this.$essentia.fetch(['shop/order', hash]);
      console.log('Order', data);
      this.order = {};
      if (data && data._id) {
        this.order = data;
        this.success = true;
      }
      this.loaded = true;
      this.loading = false;

      this.$nextTick(() => this.showQR());
    }
  }
};
</script>

<style>
.canvas-holder {
  display: inline-block;
  margin: auto;
  padding:20px;
  background-color: white;
  line-height: 0;
}
</style>
